import simpleFetch from "../../../utils/simpleFetch";

class WithdrawalApi {
  static request(model, body, headers, options, query) {
    return simpleFetch("post", model.path, { body, headers, options, query });
  }
}

export default WithdrawalApi;



// WEBPACK FOOTER //
// ./src/components/withdrawal/withdrawalApi.js